import LifePolicy from '../containers/LifePolicy'
import NewLifePolicyContainer from '../containers/NewLifePolicyContainer'
import LifePolicyList from '../containers/LifePolicyList'
import LifePolicyDetailContainer from '../containers/LifePolicyDetailContainer'
import LifeOutstandingRequirementContainer from '../containers/LifeOutstandingRequirementContainer'
import TransferInContainer from '../containers/TransferInContainer'

export default {
  path: 'life',
  name: 'Life Policy',
  component: LifePolicy,
  meta: { label: 'osm.contents.lifePolicy.header' },
  redirect: '/osm/life/list',
  children: [{
      path: 'new',
      name: 'Create Life Policy',
      meta: { label: 'osm.contents.lifePolicy.new' },
      component: NewLifePolicyContainer
    }, {
      path: 'list',
      name: 'Life Policy List',
      component: LifePolicyList,
      meta: { label: 'osm.contents.lifePolicy.lifePolicyList' },
      props: true,
    }, {
      path: 'detail',
      name: 'Life Policy Detail',
      meta: { label: 'osm.contents.lifePolicy.lifeDetail' },
      component: LifePolicyDetailContainer
    }, {
      path: 'or',
      name: 'Life Outstanding Requirement',
      meta: { label: 'osm.contents.lifePolicy.lifeOr' },
      component: LifeOutstandingRequirementContainer
    },
    {
      path: 'transferIn',
      name: 'Transfer In Life Policy',
      meta: { label: 'osm.contents.lifePolicy.lifeTransferIn' },
      component: TransferInContainer
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Osm/LifePolicy/route/index.js